import { SxProps, Theme } from "@mui/material";

export const styles: Record<string, SxProps<Theme>> = {
  modalContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.9)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 2000,
  },
  closeButton: {
    position: "absolute",
    top: 20,
    right: 20,
    color: "white",
  },
  navButton: {
    color: "white",
    backgroundColor: "rgba(255,255,255,0.1)",
    "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
  },
  prevButton: {
    position: "absolute",
    left: 20,
  },
  nextButton: {
    position: "absolute",
    right: 20,
  },
  counter: {
    position: "absolute",
    bottom: 20,
    left: "50%",
    transform: "translateX(-50%)",
    color: "white",
    backgroundColor: "rgba(0,0,0,0.5)",
    borderRadius: "12px",
    px: 2,
    py: 0.5,
    fontSize: "0.9rem",
    userSelect: "none",
  },
  image: {
    maxWidth: "90vw",
    maxHeight: "90vh",
    borderRadius: "8px",
    objectFit: "contain",
  },
};
